import React from "react";
import Menu from "./components/Menu";
import "./App.css";
import { Button, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import Descripcion from "./components/Descripcion";
import Galeria from "./components/Galeria";
import Equipo from "./components/Equipo";
import Contacto from "./components/Contacto";
import AnimatedLetters from './components/AnimatedLetters';
import { useEffect, useState } from 'react';

function App() {
  const [letterClass, setLetterClass] = useState('text-animate')
  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 1000)
  }, [])
  return (
    <ThemeProvider theme={theme}>
      {/* <img src={logo} className="App-logo" alt="logo" />

        <h1>We can dig it</h1> */}
      <Menu />
      <div className="acrylic">
        <div className="hero" id="inicio">
          <div className="text">
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['W', 'e', ' ', 'c', 'a', 'n', ' ', 'd', 'i', 'g', ' ', 'i', 't']}
              idx={15}
            />
            <Typography variant="subtitle1">
              ¿Que hay en el centro de la tierra?
            </Typography>
            <Button variant="contained" color="secondary">
              Obtener juego
            </Button>
          </div>
        </div>
        <Descripcion />
        <Galeria /> <Contacto />
        <Equipo />
      </div>
    </ThemeProvider>
  );
}

export default App;
